/**
 * Decorative, non-interactive background layer for the Hero section.
 * Extracted from Hero.jsx purely to keep the editorial content readable.
 */
export function HeroBackground() {
    return (
        <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 -z-0 select-none"
        >
            <div
                className="absolute inset-0 bg-cover bg-center opacity-30 md:opacity-40"
                style={{
                    backgroundImage: "url(/hero-bg.svg)",
                    filter: "blur(2px)",
                }}
            />
            <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#F9F9F8] to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#F9F9F8] to-transparent" />
            <div className="hidden lg:block absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-[#F9F9F8] via-[#F9F9F8]/70 to-transparent" />
        </div>
    );
}
